import { html } from "lit-element";
import { DrawSVGBaseModule } from "../../ModuleBase/svg-base-module";

export class DrawVdHor1Module extends DrawSVGBaseModule {
	constructor(canvas) {
		super(canvas);

		this.name = "vd-hor-1";
		this.icon = svg_vd_hor_1;
	}
}

window.customElements.define("inspx-draw-vd-hor-1-module", DrawVdHor1Module);

const svg_vd_hor_1 = html`
<svg width="60" height="30" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
 <g>
  <title>Layer 1</title>
  <rect fill="#ffffff" x="0" y="0" width="59.65328" height="30" id="svg_2" stroke="#444444"/>
  <line fill="none" stroke-dasharray="null" stroke-linejoin="null" stroke-linecap="null" x1="30" y1="30" x2="30" y2="0" id="svg_1" stroke="#444444"/>
  <text fill="#000000" stroke-width="0" stroke-dasharray="null" stroke-linejoin="null" stroke-linecap="null" x="19.34461" y="23.22038" id="svg_4" font-size="24" font-family="Sans-serif" text-anchor="middle" xml:space="preserve" transform="matrix(1.7179074470289712,0,0,1,-3.3574399229083745,0) " stroke="#444444">VD</text>
 </g>
</svg>`;
